import React from 'react';
import { TableRow, TableHeading } from 'models/interfaces/Table';
import PaginationComponent from 'views/components/Pagination/PaginationComponent';
import './Table.scss';

interface TableComponentProps {
  data: TableRow[];
  headings: TableHeading[];
  customClass?: string;
  onSort?: Function;
  sort?: string;
  search?: string;
  size?: number;
  from?: number;
  resultsCount?: number;
  updatePage?: (from: number, size: number) => void;
}

class Table extends React.Component<TableComponentProps, {}> {
  public constructor(props: TableComponentProps) {
    super(props);

    this.state = {
      sort: ''
    };
  }

  public render() {
    const {
      data,
      headings,
      customClass,
      onSort,
      sort,
      search,
      size,
      from,
      resultsCount,
      updatePage
    } = this.props;

    return (
      <div className={`blueprint-table table-wrap ${customClass || ''}`}>
        <table className="table">
          <thead>
            <tr>
              {headings.map(head => {
                if (typeof head.value === 'function') {
                  return (
                    <th scope="col" key={`thead-${head.value}`} className={`table__col-sort`}>
                      <div>{head.value}</div>
                    </th>
                  );
                }
                if (head.sort) {
                  return (
                    <th
                      onClick={e =>
                        onSort && onSort(head.key, head.direction === 'DESC' ? 'ASC' : 'DESC')
                      }
                      className={`${head.style}`}
                      key={`thead-sort-${head.key}`}
                    >
                      {head.value}
                      {head.direction === 'ASC' ? (
                        <span className="arrow-asc">
                          <img src={`${process.env.PUBLIC_URL}/img/arrow-up.svg`} alt="arrow" />
                        </span>
                      ) : (
                        <span className="arrow-desc">
                          <img src={`${process.env.PUBLIC_URL}/img/arrow-down.svg`} alt="arrow" />
                        </span>
                      )}
                    </th>
                  );
                }
                return (
                  <th
                    scope="col"
                    key={`thead-${head.key}`}
                    className={`table__col ${head.style ? head.style : ''}`}
                  >
                    {head.value}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={`table-data-${i}`}>
                {headings.map((heading: TableHeading, i) => {
                  if (typeof row[heading.key] === 'function') {
                    return row[heading.key];
                  }
                  return (
                    <td className={heading.style ? heading.style : ''} key={`table-data-${i}`}>
                      {row[heading.key]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {size !== undefined &&
          from !== undefined &&
          updatePage !== undefined &&
          resultsCount !== undefined && (
            <PaginationComponent
              size={size}
              from={from}
              handlePageChange={updatePage}
              resultsCount={resultsCount}
            />
          )}
      </div>
    );
  }
}

export default Table;
